var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutingLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 6,
    viewBox: "0 0 167 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5L2.52368e-07 0.113249L-2.52368e-07 5.88675L5 3.5L5 2.5ZM166.887 3.00001L164 0.113263L161.113 3.00001L164 5.88677L166.887 3.00001ZM4.5 3.5L164 3.50001L164 2.50001L4.5 2.5L4.5 3.5Z",
    fill: "url(#paint0_linear_6843_5900)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6843_5900",
    x1: -2.0423e-7,
    y1: 3.75,
    x2: 2.06288,
    y2: 14.7521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0617363,
    stopColor: "#FFE249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486651,
    stopColor: "#B7FF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingLine2);
export default __webpack_public_path__ + "static/media/routing_line_2.62a4b83a226df25a8ae530866b256d7f.svg";
export { ForwardRef as ReactComponent };